// frontend/src/hooks/useEntitlements.ts — the per-project optional-module ON-set.
//
// The wire home is `/me` `permissions[projectId].entitlements` (ADR-044): the
// entitlement set rides the session/permission payload, NOT the project metadata
// read, so it's member-facing and useMe already loads it. Drives the nav
// AND-gate (`isNavItemVisible` / `entityRegistry`) — which gates entitlement even
// for admins, the same model the backend `can()` enforces. `useCan` applies the
// entitlement gate itself for catalogue-key gates; this hook is for the registry
// contexts whose gate may be synthetic ('member'/'admin') and so still need the
// explicit set.

import { useMemo } from 'react';
import type { EntitlementFlag } from '@ems-app/schemas/permissions';
import { useMe } from './useMe.js';

const EMPTY: ReadonlySet<EntitlementFlag> = new Set();

export function useEntitlements(projectId: string): ReadonlySet<EntitlementFlag> {
  const { data: me } = useMe();
  const flags = me?.permissions[projectId]?.entitlements;
  return useMemo(() => (flags ? new Set(flags) : EMPTY), [flags]);
}
